module.exports = __webpack_public_path__ + "static/img/bg20230615.0c12317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg20230615.jpg
// module id = GhKr
// module chunks = 1